import { createHmac } from 'crypto'

export function formatarCep(cep) {
  return `${cep}`.replace(/\.|\-|\_/g, '').replace(/[^a-z0-9]/gi, '')
}

export function capitalizaString(palavra) {
  if (typeof palavra !== 'string') return ''
  return palavra.charAt(0).toUpperCase() + palavra.slice(1)
}

export function capitalizeFirstLetter(name) {
  return name.replace(/\w\S*/g, function (replacedName) {
    return (
      replacedName.charAt(0).toUpperCase() +
      replacedName.substr(1).toLowerCase()
    )
  })
}

export function removerEspacos(string) {
  return string.replace(/ /g, '')
}

export function formatarHora(time) {
  if (!time) return ''

  const splitTime = time.split(':')
  return `${splitTime[0]}:${splitTime[1]}`
}

export function mascaraCep(cep) {
  return cep
    ?.toString()
    .trim()
    .replace(/(\d{5})(\d{3})/, '$1-$2')
}

export function formatarPreco(valor) {
  const formato = {
    minimumFractionDigits: 2,
    style: 'currency',
    currency: 'BRL',
  }
  return parseFloat(valor).toLocaleString('pt-BR', formato)
}

export function formatarURLImagem(atributos) {
  if (!atributos?.bucket || !atributos?.chave) {
    return null
  }
  const operationUrl = `origxorig/filters:format(webp):quality(90)/https://${atributos.bucket}.s3.amazonaws.com${atributos.chave}`

  if (process.env.THUMBOR_KEY) {
    let key = createHmac('sha1', process.env.THUMBOR_KEY)
      .update(operationUrl)
      .digest('base64')

    key = key.replace(/\+/g, '-').replace(/\//g, '_')

    return `${process.env.THUMBOR_URL}/${key}/${operationUrl}`
  } else {
    return atributos?.url
  }
}

export function formatarDataHora(
  dateTimeString,
  locale = 'pt-BR',
  options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }
) {
  // A class Date aceita somente datas no formato da ISO 8601, como descrito na
  // especificação (https://tc39.es/ecma262/#sec-date-time-string-format).
  // Nos browsers desktop e no chome para android, ainda sim funciona com o espaço,
  // porém no chrome/safari para iOS o formato da data é mais rigoroso.
  if (!dateTimeString) return ''
  const dataIso8601 = dateTimeString.replace(' ', 'T')
  const date = new Date(dataIso8601)

  return date.toLocaleString(locale, options)
}

export function formatarDataPadraoBancoDeDados(
  dateString,
  locale = 'pt-BR',
  options = { timeZone: 'UTC' }
) {
  const date = new Date(dateString)

  return date.toLocaleDateString(locale, options)
}

export function parseDateStringToDate(dateString) {
  const [day, month, year] = dateString.split(/\D/)
  return new Date(year, month - 1, day)
}

export function isDate(date) {
  return date instanceof Date
}

export function formatarEmail(string) {
  return string.replace(/[^a-z0-9-@-_.]/gi, '')
}

export function formatarDataString(data) {
  const explode = data.split('/')
  return `${explode[2]}-${explode[1]}-${explode[0]}`
}

export function dataFormatada(data) {
  const arrayData = data.split('-')
  return `${arrayData[2]}/${arrayData[1]}/${arrayData[0]}`
}

export function dayOfData(data) {
  const date = new Date(data)
  switch (date.getUTCDay()) {
    case 0:
      return 'domingo'
    case 1:
      return 'segunda-feira'
    case 2:
      return 'terça-feira'
    case 3:
      return 'quarta-feira'
    case 4:
      return 'quinta-feira'
    case 5:
      return 'sexta-feira'
    case 6:
      return 'sábado'
  }
}

export function validarCPF(cpf) {
  const strCPF = cpf.replace(/[-.]/g, '')

  if (strCPF.length === 11) {
    var Soma
    var Resto
    Soma = 0

    if (
      strCPF === '00000000000' ||
      strCPF === '11111111111' ||
      strCPF === '22222222222' ||
      strCPF === '33333333333' ||
      strCPF === '44444444444' ||
      strCPF === '55555555555' ||
      strCPF === '66666666666' ||
      strCPF === '77777777777' ||
      strCPF === '88888888888' ||
      strCPF === '99999999999'
    )
      return false

    for (var i = 1; i <= 9; i++) {
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i)
    }

    Resto = (Soma * 10) % 11

    if (Resto === 10 || Resto === 11) Resto = 0
    if (Resto !== parseInt(strCPF.substring(9, 10))) return false

    Soma = 0
    for (i = 1; i <= 10; i++)
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i)
    Resto = (Soma * 10) % 11

    if (Resto === 10 || Resto === 11) Resto = 0
    if (Resto !== parseInt(strCPF.substring(10, 11))) return false

    return true
  }
}

export function validarDuasOuMaisPalavras(string) {
  return string.trim().split(' ').length > 1
}

export function validarEndereco(address) {
  const hasApostrophe = address.includes("'")
  const hasQuote = address.includes('"')

  return !(hasApostrophe || hasQuote)
}

export function base64PDF(base64str, titulo = 'Gazin - Imprima seu boleto') {
  let pdfWindow = window.open('about:blank', '_blank')
  pdfWindow.document.write(`<title>${titulo}</title>`)
  pdfWindow.document.write(
    '<style>*{border: 0; padding: 0; margin: 0; width: 100%; box-sizing: border-box;}</style>'
  )
  pdfWindow.document.write(
    "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
      encodeURI(base64str) +
      "'></iframe>"
  )

  return pdfWindow.document.close()
}

export function agruparPorParametro(arr, key) {
  var newArr = [],
    types = {},
    i,
    j,
    cur
  for (i = 0, j = arr.length; i < j; i++) {
    cur = arr[i]
    if (!(cur[key] in types)) {
      types[cur[key]] = {
        type: cur[key],
        data: [],
      }
      newArr.push(types[cur[key]])
    }
    types[cur[key]].data.push(cur)
  }
  return newArr
}

export function separarDDD(telefone) {
  const explode = telefone.replace(/[{(}]/g, '').split(')')
  const ddd = explode[0]
  const numero = explode[1]

  return {
    ddd,
    numero,
  }
}

export function removerTags(str) {
  if (str === null || str === '' || str === undefined) return false
  else str = str.toString()
  return str
    .replace(/(<([^>]+)>)/gi, '')
    .normalize('NFD')
    .replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
    .replace(/(\r\n|\n|\r)/gm, ' ')
    .substr(0, 215)
}

export function formatPeriod(date, middleWord) {
  return new Date(date)
    .toLocaleString('pt-BR', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
    .split(' ')
    .join(` ${middleWord} `)
}

export function formatPeriodAsString(datetime, middleWord) {
  const split =
    datetime.search('T') !== -1 ? datetime.split('T') : datetime.split(' ')
  const date = split[0].split('-')
  const hour = split[1].split(':')

  return `${date[2]}/${date[1]}/${date[0]} ${middleWord} ${hour[0]}:${hour[1]}`
}
